import { TipoColunaEnum } from "./tipo-coluna.enum";

export interface IColumModel {
    prop: string,
    nome: string,
    tipo?: TipoColunaEnum,
}

export class ColumnModel implements IColumModel{
    prop: string;
    nome: string;
    tipo?: TipoColunaEnum;

    constructor(prop: string, nome: string, tipo?: TipoColunaEnum){
        this.prop = prop;
        this.nome = nome;

        if(tipo) {
            this.tipo = tipo;
        }
    }
}

